import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const TrackingIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "TrackingIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}

      <path
        d="M12 15.3448C10.1556 15.3448 8.65517 13.8444 8.65517 12C8.65517 10.1556 10.1556 8.65517 12 8.65517C13.8444 8.65517 15.3448 10.1556 15.3448 12C15.3448 13.8444 13.8444 15.3448 12 15.3448ZM12 10.1689C10.9903 10.1689 10.1689 10.9903 10.1689 12C10.1689 13.0097 10.9903 13.8311 12 13.8311C13.0097 13.8311 13.8311 13.0097 13.8311 12C13.8311 10.9903 13.0097 10.1689 12 10.1689Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M12 19.719C7.74357 19.719 4.28097 16.2564 4.28097 12C4.28097 7.74355 7.74356 4.28096 12 4.28096C16.2564 4.28096 19.719 7.74355 19.719 12C19.719 16.2564 16.2564 19.719 12 19.719ZM12 5.79471C8.5783 5.79471 5.79471 8.57829 5.79471 12C5.79471 15.4217 8.57829 18.2053 12 18.2053C15.4217 18.2053 18.2053 15.4217 18.2053 12C18.2053 8.57829 15.4217 5.79471 12 5.79471Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M12 22C11.5821 22 11.2431 21.661 11.2431 21.2431V19.0351C11.2431 18.6172 11.5821 18.2782 12 18.2782C12.4179 18.2782 12.7569 18.6172 12.7569 19.0351V21.2431C12.7569 21.661 12.4179 22 12 22Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M12 5.69617C11.5821 5.69617 11.2431 5.35715 11.2431 4.93929V2.75687C11.2431 2.33902 11.5821 2 12 2C12.4179 2 12.7569 2.33902 12.7569 2.75687V4.93929C12.7569 5.35715 12.4179 5.69617 12 5.69617Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M4.96492 12.7569H2.75687C2.33902 12.7569 2 12.4179 2 12C2 11.5821 2.33902 11.2431 2.75687 11.2431H4.96492C5.38277 11.2431 5.72179 11.5821 5.72179 12C5.72179 12.4179 5.38277 12.7569 4.96492 12.7569Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M21.2431 12.7569H19.0607C18.6429 12.7569 18.3038 12.4179 18.3038 12C18.3038 11.5821 18.6429 11.2431 19.0607 11.2431H21.2431C21.661 11.2431 22 11.5821 22 12C22 12.4179 21.661 12.7569 21.2431 12.7569Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default TrackingIcon;
